export const AffiliateMarketingUrl = {
    amazon: 'https://www.amazon.in/?&_encoding=UTF8&tag=zestmoney-21&linkCode=ur2&linkId=3a72d355b2763d75c9e8ab44f24a2519&camp=3638&creative=24630',
    flipkart: 'http://fkrt.it/2NPtj!NNNN',
    makemytrip: 'https://www.makemytrip.com/',
    cleartrip: 'https://www.cleartrip.com/',
    jabong: 'https://www.jabong.com/',
    urbanladder: 'https://www.urbanladder.com/',
    myntra : 'https://www.myntra.com/'
};

export class MerchantSetting {
    partnerName: string;
    walletId: string;
    merchantId: string;
    paymentGatewayId: string;
    maxLimit: number;
    minLimit: number;
    denomination: number;
    isActive: boolean;
    isOffline: boolean;
    isPayLater: boolean;
    isSkipDownpayment: boolean;
    order: number;
}

export interface MerchantSettings {
    giftCardPartnerList: MerchantSetting[];
}
